import React, { useEffect, useState } from "react";
import {
    ContenedorTitulo,
    Main,
    Titulo
} from "../TestMapa/AlcantarillaElements";
import Tabla from "../Historico/Tabla/index"
import API from '../../services/api-service';
import { Button } from "react-bootstrap";


const Tracking = () => {
    const itemsPerPageOptions = [5, 10, 20, 50, 100, 200];
    const columnValues = [
        { nColumna: 'ID', nValor: 'deviceId' },
        { nColumna: 'Placa', nValor: 'vehicleIdentification' },
        { nColumna: "Acciones", nValor: 'acciones' }
    ]

    const [devices, setDevices] = useState([]);

    useEffect(() => {
        API.getTrackerDevices().then((response) => {
            setDevices(response.data);
        }).catch((error) => {
            console.error(error);
        })
    }, []);

    return (
        <>
            <Main>
                <ContenedorTitulo>
                    <Titulo>Vehículos registrados</Titulo>
                </ContenedorTitulo>

                <Button style={{ margin: "0 0 5px 5px" }}>
                    Rastrear todos
                </Button>
            </Main>
            <Main>
                {devices.length > 0 ? <Tabla data={devices} itemsPerPageOptions={itemsPerPageOptions} columnValues={columnValues} /> : <>No hay dispositivos disponibles</>}
            </Main>
        </>
    )

}

export default Tracking